import React from "react";
import classNames from "classnames";
import { HeaderSearch } from "Components/Layout";
import { DesignContextProvider } from "Components/DesignContext";
import * as Icons from "Components/Icons";

const WorkplaceSearchForm: React.FC = () => {
   const placeholder = "Search by city, neighborhood, or address";

   return (
      <DesignContextProvider name="primary">
         <HeaderSearch
            className={classNames("header-search", "hp3-search")}
            onButtonClick={() => undefined}
            ariaLabel="Search"
            placeholder={placeholder}
            elementRootContainerId="hp3-hero-search-input"
            buttonContent={() => (
               <>
                  <span className="hp3-search-btn-label">Search</span>
                  <Icons.Find className="hp3-search-btn-icon" aria-hidden="true" />
               </>
            )}
         />
      </DesignContextProvider>
   );
};

export default WorkplaceSearchForm
